<template>
  <div>
    <el-card>
      <div class="filter-container">
        <el-input v-model="listQuery.account" placeholder="账号" style="width: 200px;" />
        <el-input v-model="listQuery.username" placeholder="用户名" style="width: 200px; margin-left: 10px;" />
        <el-button type="primary" @click="handleFilter">搜索</el-button>
        <el-button type="success" @click="handleCreate">新增用户</el-button>
      </div>

      <el-table
        :data="list"
        border
        fit
        highlight-current-row
        style="width: 100%; margin-top: 20px;"
      >
        <el-table-column prop="id" label="ID" width="120" /> 
        <el-table-column prop="account" label="账号" width="120" />
        <el-table-column prop="username" label="用户名" width="150" />
        <el-table-column prop="balance" label="余额" width="100" />
        <el-table-column prop="frozen_amount" label="冻结金额" width="100" />
        <el-table-column prop="deposit" label="存款金额" width="100" />
        <el-table-column prop="interestRate" label="利率" width="80" />
        <el-table-column label="操作" align="center">
          <template #default="{ row }">
            <el-button type="primary" size="small" @click="handleRecharge(row)">充值</el-button>
            <el-button type="warning" size="small" @click="handleDeposit(row)">存取款</el-button>
            <el-button type="info" size="small" @click="handleInterestRate(row)">修改利率</el-button>
            <el-button type="success" size="small" @click="handleUpdate(row)">编辑</el-button>
            <el-button type="danger" size="small" @click="handleDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.limit"
        @page-change="getList"
      />
    </el-card>

    <user-form
      :visible.sync="dialogVisible"
      :is-edit="isEdit"
      :user="currentUser"
      @refresh="getList"
    />
    <recharge-dialog :visible.sync="rechargeVisible" :user="currentUser" @refresh="getList" />
    <deposit-dialog :visible.sync="depositVisible" :user="currentUser" @refresh="getList" />
    <interest-rate-dialog :visible.sync="interestRateVisible" :user="currentUser" @refresh="getList" />
  </div>
</template>

<script>
import { getUsers, deleteUser } from '@/api/user'
import Pagination from '@/components/Pagination'
import UserForm from './components/UserForm'
import RechargeDialog from './components/RechargeDialog'
import DepositDialog from './components/DepositDialog'
import InterestRateDialog from './components/InterestRateDialog'

export default {
  name: 'UserList',
  components: { Pagination, UserForm, RechargeDialog, DepositDialog, InterestRateDialog },
  data() {
    return {
      list: [],
      total: 0,
      listQuery: {
        page: 1,
        limit: 20,
        account: '',
        username: ''
      },
      dialogVisible: false,
      rechargeVisible: false,
      depositVisible: false,
      interestRateVisible: false,
      isEdit: false,
      currentUser: {}
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      const { data } = await getUsers(this.listQuery)
      this.list = data.items
      this.total = data.total
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleCreate() {
      this.dialogVisible = true
      this.isEdit = false
      this.currentUser = {}
    },
    handleUpdate(row) {
      this.dialogVisible = true
      this.isEdit = true
      this.currentUser = { ...row }
    },
    handleDelete(row) {
      this.$confirm('确定删除该用户吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await deleteUser(row.id)
        this.getList()
        this.$message.success('删除成功')
      })
    },
    handleRecharge(row) {
      this.currentUser = { ...row }
      this.rechargeVisible = true
    },
    handleDeposit(row) {
      this.currentUser = { ...row }
      this.depositVisible = true
    },
    handleInterestRate(row) {
      this.currentUser = { ...row }
      this.interestRateVisible = true
    }
  }
}
</script>

<style scoped>
.filter-container {
  margin-bottom: 20px;
}
</style>